import styled from "styled-components";

export const StyledBody = styled.div`
  color: ${({ theme }) => theme.colors.darkgrey};
  margin-top: 12px;
  opacity: 0.7;
  font: normal normal normal 16px/22px Open Sans;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.title};
  margin-top: 12px;
  font: normal normal normal 16px/22px Open Sans;
  background: #ededed;
  padding: 10px;
  margin-bottom: 10px;
`;
